import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { getResourceUuid } from "../../utils/getResourceUuid";
import { IClassroom } from "../types/IClassroom";

export type IClassroomDuplicateMutationParameters = {
    classroom: RelationalValue<IClassroom>;
};

export type IClassroomDuplicateMutationResult = IClassroom;

export const classroomDuplicateMutation: IApiMutationFunction<IClassroomDuplicateMutationParameters> = ({
    classroom,
}) => {
    return {
        method: "POST",
        url: "/classrooms/duplicate",
        data: { uuid: getResourceUuid(classroom) },
    };
};

export const useClassroomDuplicateMutation = createApiMutationHook<
    IClassroomDuplicateMutationParameters,
    IClassroomDuplicateMutationResult
>(classroomDuplicateMutation);
